/**
 * 在途模块：运输单只读查询（牛只详情 / 订单详情「在途状态」查看态占位）
 * 架构 §4 边界：不建独立在途监管页面，仅查看态；接口未就绪时返回 null 由页面显示占位。
 */
import { get } from './http';
import { canFallbackToMock } from './errors';
import { mockTransitByCattle, mockTransitByOrder } from './mock';
import type { TransitOrder } from '@/types';

/** 按订单查询运输单（C-02：后端 GET /transit/orders 已支持 order_id 过滤 + enrich 车牌/司机/来源单号） */
export async function getTransitByOrder(orderId: number): Promise<TransitOrder | null> {
  try {
    const data = await get<{ list: TransitOrder[] }>('/transit/orders', { order_id: orderId });
    return data.list?.[0] ?? null;
  } catch (e) {
    if (canFallbackToMock(e)) return mockTransitByOrder(orderId);
    throw e;
  }
}

/** 按牛只查询运输单 */
export async function getTransitByCattle(cattleId: number): Promise<TransitOrder | null> {
  try {
    const data = await get<{ list: TransitOrder[] }>('/transit/orders', { cattle_id: cattleId });
    return data.list?.[0] ?? null;
  } catch (e) {
    if (canFallbackToMock(e)) return mockTransitByCattle(cattleId);
    throw e;
  }
}
